import { dashboardFlattenHierarchyMixedVisibilitiesMapSelector } from "@/store/dashboards/selectors/dashboard-hierarchy-visibility/dashboardFlattenHierarchyMixedVisibilitiesMapSelector";
import { RootState } from "@/store/store";

export const dashboardFlattenHierarchyMixedVisibilityItemByIdSelector = (
  state: RootState,
  id?: string,
) => {
  const data = dashboardFlattenHierarchyMixedVisibilitiesMapSelector(state);

  if (!data || !id) {
    return null;
  }

  return data[id] || null;
};
